import React from "react";
import ISOCertificationImg from "../../../Assets/ISO Certification/CertificationImg.png";

const ISOContent200001 = () => {
  return (
    <>
      <div className="w-full h-auto px-4 sm:px-10 grid grid-cols-1 xl:grid-cols-2 gap-8 bg-[#F7FAFF]">
        {/* left side */}
        <div className="w-full">
          {/* heading */}
          <div className="py-4 lg:py-10">
            <div className="text-[#032303] font-bold sm:text-3xl md:font-medium text-lg md:text-4xl">
              <h1 className="mb-3">
                <span className="border-b-4 border-[#249742]"> ISO 200</span>
                00-1:2018 Certificate
              </h1>
            </div>
          </div>

          {/* content */}
          <div>
            <p className="font-normal text-sm lg:text-xl text-[#4D4D4D]">
              ISO/IEC 20000, the international standard for service management,
              is the first formal worldwide standard, specifically aimed at
              Information Technology Service Management industries. ISO/IEC
              20000 is likely to become a basic business requirement, in the
              same way as ISO 9001
            </p>
          </div>
        </div>

        {/* right side */}
        <div className="grid grid-cols-1">
          <div className="py-0 sm:py-8">
            <img
              src={ISOCertificationImg}
              className="rounded-2xl w-full h-[421px] object-cover transition-transform duration-300 ease-in-out hover:scale-[1.02] hover:shadow-lg cursor-pointer"
              alt="Compliance certificate"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ISOContent200001;
